/**
 * Test seam for visual-regression (Sentry Snapshots) e2e runs.
 *
 * The global site header renders two indicators driven by the live socket
 * connection (`HeaderConnectionContext`): the viewer-presence avatars and the
 * connection-status cloud icon. Both reflect real-time, timing-dependent state
 * — which other users happen to be connected, whether our socket has finished
 * connecting, how many actions are still unconfirmed — so they vary run to run
 * and produce false visual diffs on every round-scoped page (the header is on
 * all of them). They are infrastructure status, not product content under test,
 * so we hide them when capturing screenshots.
 *
 * Baked in at build time (`VITE_E2E_HIDE_LIVE_INDICATORS=true`, set by the e2e
 * Playwright `webServer`). Prod-safe by construction: a real prod/staging build
 * never sets the flag, so Vite statically folds this to `false` and strips the
 * branch. (Do NOT gate behind `import.meta.env.PROD !== true`: `vite build`
 * runs in production mode, which would dead-strip the flag we rely on.)
 */
export function hideLiveHeaderIndicators(): boolean {
  return import.meta.env?.VITE_E2E_HIDE_LIVE_INDICATORS === "true";
}
